// src/utils/api.js
export const API_BASE_URL =
  process.env.REACT_APP_API_URL?.replace("/api", "") ||
  "http://localhost:8000";
